import { computed } from 'vue';
import { useRouteExtensions } from '@/use/use-route-extensions';

export const useFlowUrls = () => {
  const routeExtensions = useRouteExtensions();

  const startAanbodUrl = computed(() => {
    return `/${routeExtensions?.lang?.value}/${routeExtensions?.aanbodNaam?.value}`;
  });

  const overzichtUrl = computed(() => {
    return overzichtUrlFor(routeExtensions?.aanvraagId?.value, routeExtensions?.aanbodNaam?.value);
  });

  function overzichtUrlFor(aanvraagId, aanbodNaam) {
    return routeExtensions?.lang?.value === 'fr'
      ? `/${routeExtensions?.lang?.value}/${aanbodNaam}/vue-d-ensemble?aanvraagId=${aanvraagId}`
      : `/${routeExtensions?.lang?.value}/${aanbodNaam}/overzicht?aanvraagId=${aanvraagId}`;
  }

  const xeriusHomeUrl = computed(() =>
    routeExtensions?.lang?.value === 'fr'
      ? 'https://www.xerius.be/fr-be'
      : 'https://www.xerius.be/nl-be'
  );

  const betaaloverzichtUrl = computed(() => {
    return betaaloverzichtUrlFor(
      routeExtensions?.aanvraagId?.value,
      routeExtensions?.aanbodNaam?.value
    );
  });

  function betaaloverzichtUrlFor(aanvraagId, aanbodNaam) {
    return routeExtensions?.lang?.value === 'fr'
      ? `/${routeExtensions?.lang?.value}/${aanbodNaam}/apercu-des-paiements?aanvraagId=${aanvraagId}`
      : `/${routeExtensions?.lang?.value}/${aanbodNaam}/betaaloverzicht?aanvraagId=${aanvraagId}`;
  }

  return {
    startAanbodUrl,
    overzichtUrl,
    overzichtUrlFor,
    betaaloverzichtUrl,
    betaaloverzichtUrlFor,
    xeriusHomeUrl
  };
};
